export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "select_container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccionar contenedor"])},
          "new_container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo contenedor"])}
        }
      }
    }
  })
}